module.exports = __webpack_public_path__ + "media/images/lb/595-22d44412ddec76f7cf9de090392e0e5c.svg";